import CoreAdvancedSearch, {
    AdvancedSearchClassList,
    AdvancedSearchElements,
    AdvancedSearchSelectors,
    AdvancedSearchTexts,
} from 'ui-core/widgets/advanced-search/js/advanced-search';

import { ComponentInjector, ComponentSelector } from '@atypon/ui-utils';

class Texts extends AdvancedSearchTexts { }

class ClassList extends AdvancedSearchClassList { }

class Selectors extends AdvancedSearchSelectors {
    searchInSelect = new ComponentSelector(".advanced-search__search-in__area")
    advancedSearch = new ComponentSelector(".advanced-search")
    publicationTypeSelect = new ComponentSelector(".publication-type__select")
    publicationTypeInput = new ComponentSelector(".publication-type__label")
}

class Elements extends AdvancedSearchElements {
    advancedSearch: HTMLFormElement;
    searchInSelect: HTMLSelectElement;
    publicationTypeSelect: HTMLSelectElement;
    publicationTypeInput: HTMLInputElement;

}

interface AdvancedSearch {
    get elements(): Elements;
    get texts(): Texts;
    get classList(): ClassList;
    get selectors(): Selectors;
}

@ComponentInjector(Selectors, Elements, ClassList, Texts)
class AdvancedSearch extends CoreAdvancedSearch {

    addEventListeners(): void {
        super.addEventListeners();
        this.domUtils.addEventListener(this.elements.searchInSelect, 'change', this.abstractFieldToggle.bind(this))
        this.domUtils.addEventListener(this.elements.publicationTypeSelect, 'change', this.publicationTypeSelector.bind(this))

    }

    abstractFieldToggle() {
        const selectedSearch: string = this.elements.searchInSelect.options[this.elements.searchInSelect.selectedIndex].text
        const abstractField: HTMLInputElement = document.querySelector(".abstractField")

        if (selectedSearch === "Abstract" && !abstractField) {
            const abstractFieldInput: string = '<input hidden="hidden" class="abstractField" value="abstractField" name="target">'
            this.elements.wrapper.insertAdjacentHTML('beforeend', abstractFieldInput)
        } else {
            abstractField.remove()
        }
    }

    publicationTypeSelector() {
        const publicationSelector: HTMLSelectElement = this.elements.publicationTypeSelect
        this.elements.publicationTypeInput.setAttribute("name", publicationSelector.options[publicationSelector.selectedIndex].getAttribute("param"))
        this.elements.publicationTypeInput.setAttribute("value", publicationSelector.options[publicationSelector.selectedIndex].getAttribute("value"))
    }
}

export default AdvancedSearch;

export {
    Selectors as AdvancedSearchSelectors,
    Elements as AdvancedSearchElements,
    ClassList as AdvancedSearchClassList,
    Texts as AdvancedSearchTexts,
};